import _ from 'lodash';
import Device from '../Device';
import vp from '../../../services/api/vp';

const questions = [
  {
    type: 'select',
    options: [
      { label: 'SmartHOME™ v1', value: 'v1' },
      { label: 'CoRe+™ v2 SC', value: 'v2' },
      { label: 'Other', value: 'other' },
    ],
    label: 'step3FloModel',
    advanceOnEnter: true,
    advanceOnValue: false,
    name: 'floModel',
    model: 'floModel',
    validation: null,
    showNext: false,
  },
  {
    type: 'flo-serial',
    label: 'step3FloSerialNumber',
    advanceOnEnter: true,
    advanceOnValue: false,
    name: 'serialNumber',
    model: 'serialNumber',
    dynamicValidationRules: [
      { rule: 'required' },
      { rule: 'floSerial', model: 'floModel' },
    ],
  },
];

const addDevice = async (values, context) => {
  const { account } = context;
  const updatedValues = Object.keys(values).reduce((object, key) => {
    // eslint-disable-next-line no-param-reassign
    if (key !== 'floModel') object[key] = _.clone(values[key]);
    return object;
  }, {});

  const deviceData = {
    ...updatedValues,
    mfg: 'flo',
    deviceType: 'evse',
    ...Device.commonAddDeviceParameters(context),
  };

  return vp.addDevice(deviceData);
};

const Flo = new Device('flo', { mfg: 'flo', questions, addDevice });

export default Flo;
